<template>
<div class="rm">
  <div class="rm-form p-30">
    <div class="text-left color-red mb-15" v-if="user_not_found">
      <span style="position: relative; top: 2px; float: right;"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
        <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
      </svg></span>
      <span class="font-weight-bold">Last Name and Room Number not found</span>
    </div>
    <div v-show="!checked_pin">
      <div class="row mb-15">
        <input v-model="form.last_name" class="input-text rounded" type="text" placeholder="Last Name" />
      </div>
      <div class="row mb-15">
        <input v-model="form.room_number" class="input-text rounded" type="text" placeholder="Room Number" />
      </div>
    </div>
    <div v-show="checked_pin && pin_required">
      <div class="row mb-15">
        <input v-model="form.pin" class="input-text rounded" type="text" placeholder="PIN Number" />
      </div>
    </div>
    <div class="mb-15">
      <button v-show="!checked_pin" @click="getPinRequired()" class="btn rounded" type="button" :style="'background: ' + color_background_button + '; color: ' + color_text_button">Continue</button>
      <button v-show="checked_pin && pin_required" @click="emitRegistrationMethodData()" class="btn rounded" type="button" :style="'background: ' + color_background_button + '; color: ' + color_text_button">Continue</button>
    </div>
    <p class="text-center text-14 mb-0">By clicking continue you agree to the
      <span @click="selectTermsOfService(index)" class="text-link">Terms and Conditions</span>
    </p>
    <div class="terms-of-service text-left pt-20" v-if="selected_tos==index">
      <div v-html="registration_method.terms_of_service"></div>
      <div class="mt-30 text-center"><button class="btn-close" @click="selectTermsOfService(null)">CLOSE</button></div>
    </div>
  </div>
</div>
</template>
<script>
import {HTTP} from '@/utilities/http'

export default {
  name: 'registration_method_pan_pms',
  props: ['property_id','index','selected','selected_tos','color_background_button','color_text_button','registration_method'],
  data(){
    return{
      checked_pin: false,
      pin_required: null,
      user_not_found: false,
      form: {
        last_name: '',
        room_number: '',
        pin: '',
      },
    }
  },
  watch: {
  },
  created(){
  },
  mounted(){
  },
  methods: {
    getPinRequired: function() {
      this.checked_pin = false;
      this.pin_required = null;
      this.user_not_found = false;
      HTTP.post('skypms/pinrequired', {
        property_id: this.property_id,
        lastname: this.form.last_name,
        roomnumber: this.form.room_number
      }).then(function (response) {
        this.checked_pin = true;
        if(!response.data.data.pin_required){
          this.$emit('emitRegistrationMethodData', {
            registration_method_id: this.registration_method.registration_method_id,
            rateplan_id: this.registration_method.rate_plans[0].rateplan_id,
            last_name: this.form.last_name,
            room_number: this.form.room_number,
          });
        }
        this.pin_required = response.data.data.pin_required;
      }.bind(this)).catch(function(error) {
        this.user_not_found = true;
      }.bind(this));
    },
    selectTermsOfService:function(index){
      this.$emit('changeSelectedTOS', index);
    },
    emitRegistrationMethodData: function(){
      /*
      if(this.clicked){
        return;
      }
      this.clicked = true;
      */
      this.$emit('emitRegistrationMethodData', {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: this.registration_method.rate_plans[0].rateplan_id,
        last_name: this.form.last_name,
        room_number: this.form.room_number,
        pin: this.form.pin,
      });

    },

  }
}
</script>
<style>
</style>
